import { render, staticRenderFns } from "./EvolutionOfStartupsChart.vue?vue&type=template&id=779550d0&"
import script from "./EvolutionOfStartupsChart.vue?vue&type=script&lang=js&"
export * from "./EvolutionOfStartupsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports